var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_156",
    "data-name": "Group 156",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M17.882,19.3A11,11,0,0,1,1.181,12a10.982,10.982,0,0,1,3.34-6.066L1.392,2.808,2.807,1.393l19.8,19.8-1.415,1.414-3.31-3.31ZM5.935,7.35A8.965,8.965,0,0,0,3.223,12a9,9,0,0,0,13.2,5.838L14.4,15.81A4.5,4.5,0,0,1,8.19,9.6Zm6.979,6.978L9.672,11.086a2.5,2.5,0,0,0,3.241,3.241Zm7.893,2.264-1.431-1.43A8.935,8.935,0,0,0,20.777,12,9.005,9.005,0,0,0,9.552,5.338L7.974,3.76A11.01,11.01,0,0,1,22.819,12a10.947,10.947,0,0,1-2.012,4.592ZM11.723,7.508a4.5,4.5,0,0,1,4.769,4.769l-4.77-4.769Z",
    fill: "#a8a8a8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclose);
export default __webpack_public_path__ + "static/media/eyeclose.30fbcf1193dace5e8a0eb57947d23cb6.svg";
export { ForwardRef as ReactComponent };